import React, { useEffect, useState } from 'react'
import { Modal, Button, Loader, Message, Row } from 'rsuite'
import ApproverListDetail from './ApproverListDetail'
import CancelButton from '../../buttons/cancelButton/CancelButton'
import ViewButton from '../../buttons/viewButton/ViewButton'
import { getCheckApprover } from '../../../redux/actions/approveProject'
import notification from '../../../utils/notification'
import moment from 'moment'
import OverlayLoader from '../../OverlayLoader/OverlayLoader'

const ApproverList = ({
  approveType,
  projectversionId,
  header,
  style,
  contractModifyType,
  disabled,
  buttontext,
  workPlanCode,
  budget,
  isLoading: _isLoading,
  fetchButton = () => {},
  callCheck,
  setCallCheck = () => {},
  onValidateForm,
  statusConfirmActualResult,
}) => {
  const [approverList, setApproverList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowApproverList, setIsShowApproverList] = useState(false)

  useEffect(() => {
    if (callCheck) {
      handleCallServiceVerifyApprover()
    }
  }, [callCheck])

  useEffect(() => {
    if (!isShowApproverList) {
      setCallCheck(false)
    }
  }, [isShowApproverList])

  const handleCallServiceVerifyApprover = async () => {
    if (Array.isArray(contractModifyType) && contractModifyType.length === 0) {
      notification.open('error', {
        title: 'กรุณาระบุประเภทการแก้ไขสัญญา',
      })
      return
    }
    setIsLoading(true)
    setIsError(false)

    try {
      console.log('workPlanCode', workPlanCode)
      console.log('budget', budget)
      if (approveType == 12) {
        if (!workPlanCode || !budget) {
          notification.open('error', {
            title: `กรุณาระบุเลขแผนและจำนวนเงิน`,
            duration: 5000,
          })
          return
        }
      }

      const response = await getCheckApprover(
        projectversionId,
        approveType,
        contractModifyType,
        workPlanCode,
        budget
      )
      if (response?.values) {
        setIsShowApproverList(true)
        setApproverList(response?.values || [])
      } else {
        setApproverList([])
      }
    } catch (error) {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  const formatThaiDate = (date) => {
    const monthNames = [
      'ม.ค.',
      'ก.พ.',
      'มี.ค.',
      'เม.ย.',
      'พ.ค.',
      'มิ.ย.',
      'ก.ค.',
      'ส.ค.',
      'ก.ย.',
      'ต.ค.',
      'พ.ย.',
      'ธ.ค.',
    ]

    const d = new Date(date)
    const day = d.getDate()
    const month = monthNames[d.getMonth()]
    const year = d.getFullYear() + 543

    return `${day} ${month} ${year}`
  }

  return (
    <>
      {(_isLoading || isLoading) && <OverlayLoader />}

      <ViewButton
        icon="eye"
        onClick={() => {
          if (typeof onValidateForm === 'function') {
            onValidateForm()
          } else {
            handleCallServiceVerifyApprover()
            // setApproveType(1)
            // setIsShowApproverList(true)
          }
        }}
        style={style}
        disabled={disabled}
      >
        {buttontext || 'ตรวจสอบสายอนุมัติ'}
      </ViewButton>

      <Modal
        backdrop="static"
        full
        show={isShowApproverList}
        onHide={() => {
          setIsShowApproverList(false)
        }}
      >
        <Modal.Header>
          <Modal.Title style={{ paddingTop: 10 }}>
            {header || 'รายชื่อสายอนุมัติ'}{' '}
            {'(สายอนุมัติ ณ วันที่ ' + formatThaiDate(new Date()) + ')'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {approverList?.length > 0 ? (
            <ApproverListDetail
              dataList={approverList}
              // header={header || 'รายชื่อสายอนุมัติ'}
              approveType={approveType}
              projectversionId={projectversionId}
            />
          ) : (
            <span> ------ ไม่พบสายอนุมัติ กรุณาลองใหม่ภายหลังหรือติดต่อผู้ดูแลระบบ ------ </span>
          )}
        </Modal.Body>

        <Modal.Footer>
          {fetchButton(approverList?.length > 0 ? false : true)}
          <CancelButton
            onClick={() => {
              setIsShowApproverList(false)
            }}
          >
            ปิด
          </CancelButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ApproverList
